import { Translations } from "../i18n/translation";

class DependencyContainer {
    readonly i18n = new Translations().translations;
}

export const dependencyContainer = new DependencyContainer(); // singleton